import { render, staticRenderFns } from "./Office365BackupService.vue?vue&type=template&id=f4f241f4&"
import script from "./Office365BackupService.vue?vue&type=script&lang=js&"
export * from "./Office365BackupService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports